import { gql, useQuery } from '@apollo/client'
import { GetUserGuildProjectsQuery } from '@/types/codegen-federation'

export const GET_USER_GUILD_PROJECTS = gql`
  query getUserGuildProjects {
    guildUserProjects {
      id
      name
      isPassed
    }
  }
`

export const useUserGuildProjectQuery = () => {
  return useQuery<GetUserGuildProjectsQuery>(GET_USER_GUILD_PROJECTS, {
    errorPolicy: 'all',
  })
}
